/** Страницата за генериране. Текстът на плановете е в plans.ts, общите етикети – в common.ts. */
export default {
  nav: {
    home: "Начало",
  },
  hero: {
    eyebrow: "AI генериране",
    title: "Генерирайте всичко, което си представите",
    subtitle: "Опишете сцена, герой, продукт или настроение и нашият AI ще го генерира за секунди.",
  },
  modes: {
    image: "Изображение",
    video: "Видео",
  },
  placeholder: {
    image:
      "Кинематографичен портрет на лисица под неоновите светлини на града, тюркоазено и циан осветление, много детайли, 8K резолюция…",
    video: "Спокоен таймлапс на планина в златния час, драматични облаци в бързо движение, кинематографично 4K…",
  },
  duration: "Продължителност:",
  seconds_one: "{{count}} сек.",
  seconds_other: "{{count}} сек.",
  creditsLeft_one: "Остава {{count}} точка",
  creditsLeft_other: "Остават {{count}} точки",
  buyMoreCredits: "Купете още точки",
  signInToEarn: "Влезте, за да получите точки",
  buttons: {
    generating: "Генериране…",
    generatingVideo: "Генериране на видео…",
    wait_one: "Изчакайте {{count}} сек.",
    wait_other: "Изчакайте {{count}} сек.",
    generate: "Генерирайте",
    generateVideo: "Генерирайте видео",
    downloadImage: "Изтеглете изображението",
  },
  errors: {
    blocked: "Този промпт не е разрешен според правилата ни за допустима употреба (без съдържание със сексуален характер, насилие, омраза или незаконни действия). Моля, опишете нещо друго – не са таксувани точки.",
    outOfCredits: "Нямате достатъчно точки. Купете пакет точки, за да продължите с генерирането.",
    videoCost: "Едно видео струва 2 точки. Купете пакет точки, за да продължите с генерирането.",
    noImage: "Не беше върнато изображение. Моля, опитайте отново.",
    imageFailed: "Нещо се обърка при генерирането.",
    noVideo: "Не беше върнат адрес на видеото. Моля, опитайте отново.",
    videoFailed: "Нещо се обърка.",
  },
  result: {
    title: "Резултат",
    videoTitle: "Видео резултат",
    fallback: "Резервен доставчик: {{provider}}",
    backupProvider: "резервен",
    imageAlt: "Резултат, генериран от AI",
    prompt: "Промпт:",
    videoNote: "Изображение, генерирано от AI, с кинематографична анимация Ken Burns. Щракнете, за да спрете или пуснете.",
  },
  gallery: {
    recentImages: "Последни генерирания",
    recentVideos: "Последни видеа",
    videoMeta_one: "{{count}} сек. · {{date}}",
    videoMeta_other: "{{count}} сек. · {{date}}",
  },
  plans: {
    eyebrow: "Планове",
    title: "Нуждаете се от още точки?",
    subtitle: "Купете пакет точки, за да продължите с генерирането — еднократно плащане, а не абонамент.",
    mostPopular: "Най-популярен",
    redirecting: "Пренасочване към ДСК…",
    secureCheckout: "Сигурно плащане с карта · Еднократно плащане, без абонамент · 30-дневна гаранция за връщане на парите",
  },
  player: {
    alt: "Видео, генерирано от AI",
    loop_one: "Цикъл от {{count}} сек.",
    loop_other: "Цикъл от {{count}} сек.",
  },
};
